const route = [
    {
        path: '/activity/2023sfhd/select_chapter', //2023下书法活动
        component: function (resolve) {
            require(['VIEWS/activity/2023sfhd/select_chapter.vue'], resolve);
        },
    },
    {
        path: '/activity/2023sfhd/view/:cid', //2023下书法活动
        component: function (resolve) {
            require(['VIEWS/activity/2023sfhd/view.vue'], resolve);
        }
    },
]
export default route;
